module.exports = __webpack_public_path__ + "img/expand.33fe74d5.svg";